var map = {
	"./ideas-tips-tricks/2024-04-07t16-23_simon-dean_ideas-tips-tricks_check-your-everyday-rewards-weekly-boosters.md": [
		8314,
		314
	],
	"./ideas-tips-tricks/2024-04-08t15-51_simon-dean_ideas-tips-tricks_how-much-is-a-frequent-flyer-point-worth-to-qantas.md": [
		9404,
		404
	],
	"./ideas-tips-tricks/2024-09-03t15-04_simon-dean_ideas-tips-tricks_qantas-top-up-points-bad-value-but-how-bad.md": [
		5109,
		109
	],
	"./news/2023-03-26t13-26_simon-dean_news_welcome-to-flightformula.md": [
		8975,
		975
	],
	"./reviews/2023-04-11t13-32_simon-dean_reviews_melbourne-qantas-international-business-lounge.md": [
		6213,
		213
	],
	"./reviews/2023-04-12t13-34_simon-dean_reviews_jetstar-a321neo-flight-review-melbourne-to-bali.md.md": [
		1214,
		214
	],
	"./reviews/2023-06-18t10-01_simon-dean_reviews_qantas-a330-business-class-review-jakarta-to-melbourne.md": [
		5292,
		292
	],
	"./reviews/2023-06-28t13-53_simon-dean_reviews_batik-air-a320-flight-review-bali-to-jakarta.md": [
		1422,
		422
	],
	"./reviews/2024-04-16t11-37_simon-dean_reviews_cathay-pacific-a350-business-class-hong-kong-to-singapore.md": [
		4113,
		113
	],
	"./tidbits/2025-06-09t17-05_simon-dean_tidbits_why-has-caviar-always-been-the-ultimate-luxury-food.md": [
		5269,
		269
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3165;
module.exports = webpackAsyncContext;